import React from 'react';

import styled from 'styled-components';

import { Text, theme } from 'components';
import { Value } from './common';

interface RowProps {
  label: string | JSX.Element;
  value?: string | JSX.Element;
}

const Row: React.FC<RowProps> = ({ children, label, value }) => (
    <Container>
      <LabelColumn>
        {typeof label === 'string' ? <Label>{label}</Label> : label}
      </LabelColumn>
      <ValueColumn>{children || <Value>{value}</Value>}</ValueColumn>
    </Container>
  );

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 2px 0px;
`;

export const Label = styled(Text)`
  color: ${theme.gray8};
`;

export const LabelColumn = styled.div`
  align-self: flex-start;
  flex: 2;
  flex-grow: 2;
`;

export const ValueColumn = styled.div`
  flex: 4;
  flex-shrink: 2;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

export default Row;
